import React, {useEffect, useState} from "react";
import axios from "axios";
import Swal from "sweetalert2";
import ERPDataGrid from "../ERPDataGrid";
import "../ERPTheme.css";
import {baseUrl, ipAddress, userName,} from "../Univ";
import "bootstrap/dist/css/bootstrap.min.css";
function GoodsReceiptItem() {
    const [loading, setLoading] = useState(false);
    const [rows, setRows] = useState([]);
    const [receiptList, setReceiptList] = useState([]);
    const [itemList, setItemList] = useState([]);
    const [binList, setBinList] = useState([]);
    const [editId, setEditId] = useState(null);
    const [formData, setFormData] = useState({
        receipt: "",
        item: "",
        warehouse_bin: "",
        quantity: "",
        unit_price: "",
        total: "",
        remarks: "",
        status: 1,
        addedby: userName,
        ip_add: ipAddress,
    });
    useEffect(() => {
        getGoodsReceipt();
        getInventoryItem();
        getWarehouseBin();
        getGoodsReceiptItem();
    }, []);
    const getGoodsReceipt = () => {
        axios
            .get(baseUrl + "goods-receipt/")
            .then((res) => {
                setReceiptList(res.data);
            });
    };
    const getInventoryItem = () => {
        axios
            .get(baseUrl + "inventory-item/")
            .then((res) => {
                setItemList(res.data);
            });
    };
    const getWarehouseBin = () => {
        axios
            .get(baseUrl + "warehouse-bin/")
            .then((res) => {
                setBinList(res.data);
            });
    };
    const getGoodsReceiptItem = () => {
        setLoading(true);
        axios
            .get(baseUrl + "goods-receipt-item/")
            .then((res) => {
                setRows(res.data);
                setLoading(false);
            })
            .catch(() => {
                setLoading(false);
                Swal.fire({
                    icon: "error", title: "Error", text: "Unable to load Goods Receipt Items.",
                });
            });
    };
    const handleChange = (e) => {
        const {name, value} = e.target;
        let updatedForm = {
            ...formData, [name]: value,
        };
        if (name === "quantity" || name === "unit_price") {
            const qty = Number(name === "quantity" ? value : updatedForm.quantity || 0);
            const price = Number(name === "unit_price" ? value : updatedForm.unit_price || 0);
            updatedForm.total = (qty * price).toFixed(2);
        }
        setFormData(updatedForm);
    };
    const clearForm = () => {
        setEditId(null);
        setFormData({
            receipt: "",
            item: "",
            warehouse_bin: "",
            quantity: "",
            unit_price: "",
            total: "",
            remarks: "",
            status: 1,
            addedby: userName,
            ip_add: ipAddress,
        });
    };
    const editGoodsReceiptItem = async (row) => {
        setEditId(row.id);
        setFormData({
            receipt: row.receipt.id,
            item: row.item.id,
            warehouse_bin: row.warehouse_bin.id,
            quantity: row.quantity,
            unit_price: row.unit_price,
            total: row.total,
            remarks: row.remarks,
            status: row.status,
            addedby: userName,
            ip_add: ipAddress,
        });
        await axios.get(baseUrl + `update-goods-receipt-item/${row.id}/`);
    };
    const saveGoodsReceiptItem = () => {
        const data = new FormData();
        data.append("receipt", formData.receipt);
        data.append("item", formData.item);
        data.append("warehouse_bin", formData.warehouse_bin);
        data.append("quantity", formData.quantity);
        data.append("unit_price", formData.unit_price);
        data.append("total", formData.total);
        data.append("remarks", formData.remarks);
        data.append("status", formData.status);
        data.append("addedby", userName);
        data.append("ip_add", ipAddress);
        setLoading(true);
        const request = editId === null ? axios.post(baseUrl + "goods-receipt-item/", data) : axios.put(baseUrl + `update-goods-receipt-item/${editId}/`, data);
        request
            .then(() => {
                Swal.fire({
                    icon: "success",
                    title: "Success",
                    text: editId === null ? "Goods Receipt Item saved successfully." : "Goods Receipt Item updated successfully.",
                });
                clearForm();
                getGoodsReceiptItem();
            })
            .catch(() => {
                setLoading(false);
                Swal.fire({
                    icon: "error", title: "Error", text: "Unable to save Goods Receipt Item.",
                });
            });
    };
    const deleteGoodsReceiptItem = (id) => {
        Swal.fire({
            title: "Delete Goods Receipt Item?",
            text: "You won't be able to revert this.",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes",
        }).then((result) => {
            if (result.isConfirmed) {
                setLoading(true);
                axios
                    .delete(baseUrl + `update-goods-receipt-item/${id}/`)
                    .then(() => {
                        Swal.fire({
                            icon: "success", title: "Deleted", text: "Goods Receipt Item deleted successfully.",
                        });
                        getGoodsReceiptItem();
                    })
                    .catch(() => {
                        setLoading(false);
                        Swal.fire({
                            icon: "error", title: "Error", text: "Unable to delete Goods Receipt Item.",
                        });
                    });
            }
        });
    };
    const columns = [{
        field: "id", headerName: "ID", width: 80,
    }, {
        field: "receipt_no", headerName: "Receipt No", width: 150,
         renderCell: (params) => (params.row.receipt?.receipt_no)
    }, {
        field: "item_name", headerName: "Item", flex: 1,
        renderCell: (params) => (params.row.item?.item_name)
    }, {
        field: "bin_name", headerName: "Warehouse Bin", width: 180,
        renderCell: (params) => (params.row.warehouse_bin?.bin_name)
    }, {
        field: "quantity", headerName: "Quantity", width: 120,
    }, {
        field: "unit_price", headerName: "Unit Price", width: 120,
    }, {
        field: "total", headerName: "Total Amount", width: 140,
    }, {
        field: "status",
        headerName: "Status",
        width: 100,
        renderCell: (params) => params.value == 1 ? "Active" : "Inactive",
    }, {
        field: "action", headerName: "Action", width: 180, sortable: false, renderCell: (params) => (<>
                <button
                    className="btn btn-success btn-sm me-2"
                    onClick={() => editGoodsReceiptItem(params.row)}
                >
                    Edit
                </button>

                <button
                    className="btn btn-danger btn-sm"
                    onClick={() => deleteGoodsReceiptItem(params.row.id)}
                >
                    Delete
                </button>
            </>),
    },];
    return (<div className="container-fluid mt-3">

            <div className="card shadow">

                <div className="card-header bg-primary text-white">

                    <h5 className="mb-0">
                        Goods Receipt Item
                    </h5>

                </div>

                <div className="card-body">

                    <div className="row">

                        <div className="col-md-4 mb-3">

                            <label>Goods Receipt</label>

                            <select
                                className="form-select"
                                name="receipt"
                                value={formData.receipt}
                                onChange={handleChange}
                            >
                                <option value="">
                                    Select Receipt
                                </option>

                                {receiptList.map((item) => (<option
                                        key={item.id}
                                        value={item.id}
                                    >
                                        {item.receipt_no}
                                    </option>))}

                            </select>

                        </div>

                        <div className="col-md-4 mb-3">

                            <label>Inventory Item</label>

                            <select
                                className="form-select"
                                name="item"
                                value={formData.item}
                                onChange={handleChange}
                            >
                                <option value="">
                                    Select Item
                                </option>

                                {itemList.map((item) => (<option
                                        key={item.id}
                                        value={item.id}
                                    >
                                        {item.item_name}
                                    </option>))}

                            </select>

                        </div>

                        <div className="col-md-4 mb-3">

                            <label>Warehouse Bin</label>

                            <select
                                className="form-select"
                                name="warehouse_bin"
                                value={formData.warehouse_bin}
                                onChange={handleChange}
                            >
                                <option value="">
                                    Select Bin
                                </option>

                                {binList.map((item) => (<option
                                        key={item.id}
                                        value={item.id}
                                    >
                                        {item.bin_name}
                                    </option>))}

                            </select>

                        </div>

                        <div className="col-md-3 mb-3">

                            <label>Quantity</label>

                            <input
                                type="number"
                                className="form-control"
                                name="quantity"
                                value={formData.quantity}
                                onChange={handleChange}
                            />

                        </div>

                        <div className="col-md-3 mb-3">

                            <label>Unit Price</label>

                            <input
                                type="number"
                                className="form-control"
                                name="unit_price"
                                value={formData.unit_price}
                                onChange={handleChange}
                            />

                        </div>

                        <div className="col-md-3 mb-3">

                            <label>Total Amount</label>

                            <input
                                type="number"
                                className="form-control"
                                name="total"
                                value={formData.total}
                                readOnly
                            />

                        </div>
                        <div className="col-md-3 mb-3">

                            <label>Status</label>

                            <select
                                className="form-select"
                                name="status"
                                value={formData.status}
                                onChange={handleChange}
                            >
                                <option value={1}>Active</option>
                                <option value={0}>Inactive</option>
                            </select>

                        </div>

                        <div className="col-md-12 mb-3">

                            <label>Remarks</label>

                            <textarea
                                className="form-control"
                                rows="2"
                                name="remarks"
                                value={formData.remarks}
                                onChange={handleChange}
                            />

                        </div>

                        <div className="col-md-12 mt-3">

                            <button
                                className="btn btn-success me-2"
                                onClick={saveGoodsReceiptItem}
                                disabled={loading}
                            >
                                Save
                            </button>

                            <button
                                className="btn btn-secondary"
                                onClick={clearForm}
                            >
                                Clear
                            </button>

                        </div>

                    </div>
                    <div className="card shadow mt-3">

                        <div className="card-header bg-primary text-white">

                            <h5 className="mb-0">
                                Goods Receipt Item List
                            </h5>

                        </div>

                        <div className="card-body">

                            <div
                                style={{
                                    height: 600, width: "100%",
                                }}
                            >

                                <ERPDataGrid
                                    rows={rows}
                                    columns={columns}
                                    loading={loading}
                                    getRowId={(row) => row.id}
                                    pageSizeOptions={[10, 25, 50, 100,]}

                                    disableRowSelectionOnClick
                                />

                            </div>

                        </div>

                    </div>

                </div>

            </div>

        </div>);
}
export default GoodsReceiptItem;